module.exports = __webpack_public_path__ + "static/img/user.f07390f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/user.png
// module id = 8tHC
// module chunks = 3